<div class="container">
  <div class="left-side">
    <img class="student-photo" src="{{ eligibleUser.photo }}" />
  </div>
  <div class="right-side">
    <div class="first-line">
      <div class="student-name">
        {{ eligibleUser.firstName }} {{ eligibleUser.lastName }}
      </div>
      <div *ngIf="newsHasAuthorization" class="authorization-status">
        <label [ngClass]="applyStatusCSS()">{{ authorizationStatus }}</label>
      </div>
    </div>
    <div class="second-line">
      <div *ngIf="eligibleUser.visualized.status; else studentNotViewed">
        <label class="viewed">
          Aluno: Última visualização:
          {{ eligibleUser.visualized.visualizedDate | date : "dd/MM/yyyy" }} às
          {{ eligibleUser.visualized.visualizedDate | date : "HH:mm" }}.
        </label>
      </div>
      <ng-template #studentNotViewed>
        <label *ngIf="isStudentProfileEligible" class="not-viewed">
          Aluno: não visualizou.
        </label>
      </ng-template>
    </div>
    <div class="third-line">
      <div *ngIf="eligibleUser.parent.visualized.status; else notViewed">
        <label class="viewed">
          Responsável:
          <strong>
            {{ eligibleUser.parent.firstName }}
            {{ eligibleUser.parent.lastName }}.
          </strong>
          Última visualização:
          {{
            eligibleUser.parent.visualized.visualizedDate | date : "dd/MM/yyyy"
          }}
          às
          {{ eligibleUser.parent.visualized.visualizedDate | date : "HH:mm" }}.
        </label>
      </div>
      <ng-template #notViewed>
        <label *ngIf="isResponsibleProfileEligible" class="not-viewed">
          Responsável:
          <strong>
            {{ eligibleUser.parent.firstName }}
            {{ eligibleUser.parent.lastName }}
          </strong>
          não visualizou.
        </label>
      </ng-template>
      <div
        *ngIf="
          eligibleUser.authorized &&
          eligibleUser.parent._id == eligibleUser.authorized.idUser
        "
      >
        <div class="authorization-detail">
          <div *ngIf="eligibleUser.authorized.answer; else notAuthorized">
            Autorizou em
            {{ eligibleUser.authorized.answerDate | date : "dd/MM/yyyy" }} às
            {{ eligibleUser.authorized.answerDate | date : "HH:mm" }}.
          </div>
          <ng-template #notAuthorized>
            Não autorizou em
            {{ eligibleUser.authorized.answerDate | date : "dd/MM/yyyy" }} às
            {{ eligibleUser.authorized.answerDate | date : "HH:mm" }}.
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
